/*
 * File: createAuthCode.ts
 * Project: meki
 * File Created: Monday, 12th December 2022 10:51:29 am
 * Author: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Last Modified: Wednesday, 21st December 2022 6:13:02 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2022 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */
import { gql } from '@apollo/client';
import { ResolverParams } from '@queries/queries.interfaces';

export const CreateAuthCodeMutation = () => gql`
  mutation CreateAuthCode($params: CreateAuthCodeParams!) {
    createAuthCode(params: $params) {
      msg
    }
  }
`;

export type CreateAuthCodeParams = ResolverParams<{
  email: string;
  browser: string;
  device: string;
}>;

export type CreateAuthCodeMutationResponse = {
  createAuthCode: {
    msg: string;
  };
};
